import React, { Component } from 'react';
import PropTypes from 'prop-types';
import graphql from 'graphql';
import Helmet from 'react-helmet';
import BlogCard from '../components/BlogCard';

export default class TagTemplate extends Component {
  render() {
    const { pathContext, data } = this.props;
    const { allMarkdownRemark: post, allFile } = data;
    const tag = pathContext.tag;
    const blog = post.edges.filter(blogPost => blogPost.node.frontmatter.contentType === 'blog');
    const tagsArray = [];
    blog.map(({ node: blogPost }) =>
      // eslint-disable-next-line
      blogPost.frontmatter.tags.map(targetTag => {
        if (targetTag.name === tag) {
          tagsArray.push(blogPost);
        }
      }),
    );
    const imagesArray = [];
    allFile.edges.map(({ node: file }) => imagesArray.push(file));
    return (
      <div>
        <Helmet title={`Tagged in ${tag}`} />
        <section className="container blog-posts-container">
          <h1 className="is-size-3">{`Articles tagged in ${tag}`}</h1>
          {tagsArray.map((blogPost, i) => <BlogCard key={i} post={blogPost} imagesArray={imagesArray} />)}
        </section>
      </div>
    );
  }
}

TagTemplate.propTypes = {
  data: PropTypes.object,
  pathContext: PropTypes.object,
};

export const pageQuery = graphql`
  query TagPage {
    allMarkdownRemark(limit: 1000, sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          frontmatter {
            title
            contentType
            date(formatString: "MMMM DD, YYYY")
            path
            summary
            author
            postimage
            tags {
              name
            }
          }
        }
      }
    }
    allFile(filter: { absolutePath: { regex: "/images/" } }) {
      edges {
        node {
          absolutePath
          relativePath
          childImageSharp {
            sizes(maxWidth: 630) {
              ...GatsbyImageSharpSizes
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/tag.js